import { render, staticRenderFns } from "./DataMapping.vue?vue&type=template&id=187a06d2&scoped=true"
import script from "./DataMapping.vue?vue&type=script&lang=js"
export * from "./DataMapping.vue?vue&type=script&lang=js"
import style0 from "./DataMapping.vue?vue&type=style&index=0&id=187a06d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a06d2",
  null
  
)

export default component.exports